import * as helper from './../../../../../VX/View/Assets/Js/helper';
import * as Events from './Events';
import {chat1_16} from "./FakeChat1_16";
import {chat2_16} from "./FakeChat2_16";
import {chat3_16} from "./FakeChat3_16";
import {chat1_18} from "./Fakechat1_18";
import {chat2_18} from "./Fakechat2_18";
import {chat3_18} from "./Fakechat3_18";
import {getPerson} from "./PeopleGetter";
import {textReplacer} from "./TextReplacer";

export function initFakeChatters() {
	const chat = helper.$('#chatroom');
	const ab3 = parseInt(helper.getData(chat, 'ab3'));
	const age = parseInt(helper.getData(chat, 'age'));
	let interval;
	let seconds = 0;
	let chatCount = 0;

	let flow;
	switch (ab3) {
		case 2:
			if (age === 18) {
				flow = chat3_18;
			} else {
				flow = chat3_16;
			}
			break;
		case 1:
			if (age === 18) {
				flow = chat2_18;
			} else {
				flow = chat2_16;
			}
			break;
		case 0:
		default:
			if (age === 18) {
				flow = chat1_18;
			} else {
				flow = chat1_16;
			}
			break;
	}

	const guestUsers = flow.map((item) => item.user)
		.filter((item) => item.substr(0, 1) !== '{')
		.filter((value, index, original) => original.indexOf(value) === index);

	const counter = chat.querySelector('#peoplecounter');
	const peopleHolder = chat.querySelector('.float');
	for (let user of guestUsers) {
		peopleHolder.append(helper.stringToHtml(
			`<div class="person paytour" data-hostid="0" style="background-image: url(/VX/Chatroom/img/images/placeholder_male.jpg);">
				<div class="name">${user}<img src="/VX/Chatroom/img/icons/male-line.svg" alt=""></div>
			</div>`));
	}

	counter.innerText = 'User online: ' + peopleHolder.querySelectorAll('.person').length;

	const chatting = () => {
		seconds++;
		const first = flow.find((item) => {
			const [min, sec] = item.time.split(':');

			let number = parseInt(min) * 60 + parseInt(sec);
			return number === seconds;
		});

		if (first !== undefined) {
			const isModel = first.user.includes("_model");
			const message = textReplacer(first.message, first.user);

			if (!isModel) {
				helper.triggerEvent(window, Events.MESSAGE_SENT, {
					name: first.user,
					id: 0,
					message: message,
					image: '/VX/Chatroom/img/images/placeholder_male.jpg',
					type: 'host'
				})
			} else {
				const current = getPerson(first.user);

				helper.triggerEvent(window, Events.MESSAGE_SENT, {
					name: current.name,
					id: current.id,
					message: message,
					image: current.avatar,
					type: 'host'
				})
			}

			chatCount++;
			if (chatCount === flow.length - 1) {
				helper.triggerEvent(window, Events.CREATE_SIGNUP, {lock: true});
			}
		}
	};

	helper.addEventListener(window, Events.PAUSE_CHAT, () => {
		clearInterval(interval);
	})
	helper.addEventListener(window, Events.RESUME_CHAT, () => {
		helper.wait(Math.random() * 3)
			.then(() => {
				interval = setInterval(chatting, 1000);
			})
	})

	helper.addEventListener(window, Events.USERNAME_SELECTED, (data) => {
		peopleHolder.append(helper.stringToHtml(
			`<div class="person" style="background-image: url(/VX/Chatroom/img/images/placeholder_${data.detail.gender}.jpg);">
				<div class="name">${data.detail.name}<img src="/VX/Chatroom/img/icons/${data.detail.gender}-line.svg" alt=""></div>
			</div>`));
		counter.innerText = 'User online: ' + peopleHolder.querySelectorAll('.person').length;
	})

	interval = setInterval(chatting, 1000);
}
